<template>
  <BaseModal
    :heading="t('global.pages.product_imports')"
    parentRoute="product-imports"
  >
    <Flex
      :direction="$screen === 's' ? 'column' : 'row'"
      :justify="$screen === 's' ? 'center' : 'between'"
      :align="$screen === 's' ? 'stretch' : 'center'"
    >
      <BaseHeading v-if="selectedImport">
        {{ t('products.imported_on', {
              amount: selectedImport.productsCount,
              date: importDate
            }) }}
      </BaseHeading>
      <BaseButton
        v-if="selectedImport"
        :loading="saving"
        @click="submit"
        v-test="'product-import-action'"
      >
        {{ filters.capitalize(
              t(
                isDeleted
                  ? 'global.actions.restore_item'
                  : 'global.actions.delete_item',
                { item: t('global.items.product', 2) }
              )
            ) }}
      </BaseButton>
    </Flex>
    <Flex direction="column">
      <BaseSpinner v-if="loading && !firstFetchFinished" />
      <BaseTable
        v-if="products?.length"
        v-test="'import-modal-products'"
        :headers="[t('global.items.product', 1), t('global.price')]"
        :rows="
            products?.map((item) => ({
              id: item.id,
              cells: [
                item.name,
                filters.currency(item.price)
              ],
            }))
          "
      />
      <LoadMore
        v-show="firstFetchFinished && !allDataFetched"
        @shown="fetchMore"
      />
      <BaseText v-if="firstFetchFinished && !products?.length">
        {{ t('global.no_results') }}
      </BaseText>
    </Flex>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { usePagination } from '@/apollo/pagination';
import LoadMore from '@/components/LoadMore.vue';
import filters from '@/filters';
import { GET_PRODUCTS } from './graphql';
import { openConfirmationModal } from './utils';

const route = useRoute();
const { t } = useI18n();

const saving = ref(false);
const importId = computed(() => parseInt(route.params.id as string));

const imports = inject<Ref<any[]>>('page-items');
const selectedImport = computed(() =>
  imports?.value?.find((item) => item.id === importId.value),
);

const importDate = computed(() =>
  filters.date(selectedImport.value?.createdAt),
);

const isDeleted = computed(() => selectedImport.value?.state === 'deleted');

const submit = () => {
  openConfirmationModal(importId.value, isDeleted.value, saving).finally(() => {
    saving.value = false;
  });
};

const { products, allDataFetched, loading, firstFetchFinished, fetchMore } =
  usePagination({
    fieldName: 'products',
    query: GET_PRODUCTS,
    variables: {
      search: '',
      importId: importId.value,
    },
  });
</script>
